// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"yn-z","badgeLink":"zn-z","category":"An-z"};